import { render } from "./RequiredPOSM.vue?vue&type=template&id=ad9c20f2&scoped=true"
import script from "./RequiredPOSM.vue?vue&type=script&lang=js"
export * from "./RequiredPOSM.vue?vue&type=script&lang=js"

import "./RequiredPOSM.vue?vue&type=style&index=0&id=ad9c20f2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9c20f2"]])

export default __exports__